import { Box, Icon, Link, Popover, Separator, ShimmerText, Text, VStack } from '@betterment/samba-react';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { LoadingStatus, PersonalProfile } from './data';
import SidebarButton, { baseUnstyledButtonStyles } from './SidebarButton';

interface ProfileMenuProps {
  personalProfile?: PersonalProfile | null;
  loadingStatus: LoadingStatus;
  reload: () => void;
}

const ProfileMenu = ({ personalProfile, loadingStatus, reload }: ProfileMenuProps) => {
  if (loadingStatus === 'error') {
    return (
      <SidebarButton onClick={reload} label="Reload profile">
        <SidebarButton.Content showMenuIcon={false}>
          <SidebarButton.ErrorState />
        </SidebarButton.Content>
      </SidebarButton>
    );
  }

  if (loadingStatus === 'loading' || !personalProfile) {
    return (
      <Box css={baseUnstyledButtonStyles}>
        <SidebarButton.Content>
          <VStack data-color-mode="dark" css={{ gap: 'space.50' }}>
            <ShimmerText css={{ maxWidth: '33%' }} textStyle="text25" />
            <ShimmerText css={{ maxWidth: '66%', maxHeight: '14px' }} textStyle="text25" />
          </VStack>
        </SidebarButton.Content>
      </Box>
    );
  }

  return (
    <Popover css={{ zIndex: 100 }}>
      <Popover.Trigger css={baseUnstyledButtonStyles}>
        <SidebarButton.Content>
          <Text color="text.onPrimary" variant="text50" css={{ fontWeight: 'medium' }}>
            {personalProfile.firstName}
          </Text>
          <Text variant="text25" color="text.onPrimary">
            {personalProfile.jobTitle}
          </Text>
        </SidebarButton.Content>
      </Popover.Trigger>
      <Popover.Content css={{ zIndex: 100 }} side="right" align="end">
        <VStack css={{ gap: 'space.100', maxWidth: '300px' }}>
          <Box>
            <Text as="p" css={{ fontWeight: 'medium' }}>
              {personalProfile.firstName}
            </Text>
            <Text>{personalProfile.jobTitle}</Text>
          </Box>
          <Link href={urlBuilder.profile()}>Betterment at Work profile</Link>
          <Separator css={{ my: 'space.50' }} />
          {!personalProfile.isAdvisor && (
            <Link
              target="_blank"
              href="https://wwws.betterment.com"
              css={{ d: 'flex', alignItems: 'center', gap: 'space.50' }}
            >
              Your employee account <Icon name="Open" size="xsmall" />
            </Link>
          )}
          <Link data-method="delete" href={urlBuilder.signOut()}>
            Log out
          </Link>
        </VStack>
      </Popover.Content>
    </Popover>
  );
};

export default ProfileMenu;
